import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import {
  ApiService,
  Hostel
} from './services/api/api.service';

export const hostelResolver: ResolveFn<Hostel | null> = (route, state) => {
  const apiService = inject(ApiService);
  // if (isPlatformServer(platformId)) {
  //   console.log('ON SERVER, FETCHING PROPERTY!');
  //   return apiService.getProperty(route.paramMap.get('id')!).pipe(
  //     tap(hostel => {
  //       console.log('SETTING IN TRANSFER CACHE:', hostel);
  //       transferState.set(SSR_DATA, {HOSTEL: hostel})
  //     }),
  //     take(1)
  //   );
  // } else if (isPlatformBrowser(platformId)) {
  //   console.log('ON BROWSER, CHECKING TRANSFER STATE!');
  //   const cachedData = transferState.get(SSR_DATA, null);
  //   if (cachedData && cachedData['HOSTEL'] && cachedData['HOSTEL']._id === route.paramMap.get('id')) {
  //     console.log('ON BROWSER, RETURNING CACHED HOSTEL!');
  //     return of(cachedData).pipe(take(1));
  //   } else {
  //     console.log('ON BROWSER, HAVE TO REFETCH HOSTEL!');
  //     return apiService.getProperty(route.paramMap.get('id')!).pipe(take(1));
  //   }
  // }
  // return apiService.getProperty(route.paramMap.get('id')!)
  //   .pipe(
  //     take(1)
  //   )
  // ;

  // if (apiService.propertiesCache.has(route.paramMap.get('id')!)) {
  return apiService.propertiesCache.get(route.paramMap.get('id')!);
  // };

  // return apiService.getProperty(route.paramMap.get('id')!)
  //   .pipe(
  //     map(hostel => {
  //       return {
  //         data: hostel,
  //         hydratedness: HOSTEL_HYDRATION_LEVEL.FULL,
  //       }
  //     })
  //   )
  // ;
};
